import * as React from 'react';
var Title = function (_a) {
    var className = _a.className, titleText = _a.titleText, fontSize = _a.fontSize, viewAll = _a.viewAll, subtext = _a.subtext, margins = _a.margins, onClickViewAll = _a.onClickViewAll;
    return (React.createElement("div", { className: "Title " + className, style: { margin: margins } },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "header", style: { fontSize: fontSize } }, titleText),
            React.createElement("div", { className: "view-all no-select", style: { display: "" + (viewAll !== undefined ? '' : 'none') }, onClick: onClickViewAll ? onClickViewAll : undefined }, viewAll === 'less' ? 'View Less' : 'View All')),
        React.createElement("div", { className: "subtext", style: { display: "" + (subtext ? subtext : 'none') } }, subtext)));
};
export default Title;
//# sourceMappingURL=Title.js.map